export const getSystomDpi = (width: number, height: number, unit: number) => {
    let changewidth = width
    let changeheight = height
    if (unit == 2) {
        changewidth = width / 10
        changeheight = height / 10
    }
    if (unit == 1 || unit == 2) {
        if (changewidth * changeheight <= 10000) {
            return 300
        } else if (changewidth * changeheight <= 30000 && changewidth * changeheight > 10000) {
            return 150
        } else if (changewidth * changeheight <= 50000 && changewidth * changeheight > 30000) {
            return 72
        } else {
            return 45
        }
    }
}
export const mm2px = (value: number, dpi, decimal = 0) => {
    return Number(((value * dpi) / 25.4).toFixed(decimal))
}